// Import Firebase compat SDK
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBFu26A72rGE_FzVnAodIjM1Sthm0RjNsc",
  authDomain: "ragrecruit-62045.firebaseapp.com",
  projectId: "ragrecruit-62045",
  storageBucket: "ragrecruit-62045.firebasestorage.app",
  messagingSenderId: "86234915743",
  appId: "1:86234915743:web:95967a96123339d7ce93aa",
  measurementId: "G-6HRE171ZZ7"
};

// Initialize Firebase only once
let app;
let auth;
let database;

try {
  // Check if a Firebase app already exists
  if (!firebase.apps.length) {
    app = firebase.initializeApp(firebaseConfig);
    // console.log("Firebase app initialized with config:", firebaseConfig);
  } else {
    app = firebase.apps[0];
    // console.log("Using existing Firebase app");
  }
  
  // Initialize services
  auth = firebase.auth();
  database = firebase.database();
  
  // Verify services and methods are available
  // // console.log("Firebase Auth service:", auth);
  // console.log("Firebase Database service:", database);
  // console.log("GoogleAuthProvider constructor:", firebase.auth.GoogleAuthProvider);
  // console.log("EmailAuthProvider constructor:", firebase.auth.EmailAuthProvider);
  
  // Set persistence
  auth.setPersistence(firebase.auth.Auth.Persistence.SESSION)
    .then(() => {
      // console.log("Auth persistence set to browserSessionPersistence");
    })
    .catch((error) => {
      console.error("Error setting persistence:", error);
    });
    
} catch (error) {
  console.error("Firebase initialization error:", error);
  console.error("Error details:", error.message);
  console.error("Error stack:", error.stack);
}

// Test that providers are available
if (typeof firebase.auth.GoogleAuthProvider !== 'function') {
  console.error("GoogleAuthProvider is not available! Check Firebase imports.");
}

// Export everything needed
export default firebase;
export { auth, database };